import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinActionRoute: InvariantJiraRoute = {
	name: 'legacy-gin-action',
	path: '/secure/IssueNavAction!default.jspa',
	query: ['filter|jql|issueKey'],
};
